import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { DdcAdminAiComponent } from './core/ddc-admin-ai/ddc-admin-ai.component'
import { DdcAdminPanelComponent } from './core/ddc-admin-panel/ddc-admin-panel.component'
import { DdcAgentsComponent } from './core/ddc-agents/ddc-agents.component'
import { DdcBillingComponent } from './core/ddc-billing/ddc-billing.component'
import { DdcCanvasComponent } from './core/ddc-canvas/ddc-canvas.component'
import { DdcCollectionPageComponent } from './core/ddc-collection-page/ddc-collection-page.component'
import { DdcFindAccountComponent } from './core/ddc-find-account/ddc-find-account.component'
import { DdcHomeComponent } from './core/ddc-home/ddc-home.component'
import { DdcLibraryDicComponent } from './core/ddc-library-dic/ddc-library-dic.component'
import { DdcLibraryComponent } from './core/ddc-library/ddc-library.component'
import { DdcLingoComponent } from './core/ddc-lingo/ddc-lingo.component'
import { DdcLoginComponent } from './core/ddc-login/ddc-login.component'
import { DdcNetworkComponent } from './core/ddc-network/ddc-network.component'
import { DdcNotificationsComponent } from './core/ddc-notifications/ddc-notifications.component'
import { DdcPricingComponent } from './core/ddc-pricing/ddc-pricing.component'
import { DdcResetPasswordComponent } from './core/ddc-reset-password/ddc-reset-password.component'
import { DdcSavedComponent } from './core/ddc-saved/ddc-saved.component'
import { DdcSearchComponent } from './core/ddc-search/ddc-search.component'
import { DdcSettingComponent } from './core/ddc-setting/ddc-setting.component'
import { DdcSignupComponent } from './core/ddc-signup/ddc-signup.component'
import { DdcStoreCategoryComponent } from './core/ddc-store-category/ddc-store-category.component'
import { DdcStoreComponent } from './core/ddc-store/ddc-store.component'
import { DdcUnderConstructionComponent } from './core/ddc-under-construction/ddc-under-construction.component'
import { DdcUserManagementComponent } from './core/ddc-user-management/ddc-user-management.component'
import { DdcUserProfileComponent } from './core/ddc-user-profile/ddc-user-profile.component'
import { DdcVerificationComponent } from './core/ddc-verification/ddc-verification.component'
import { AuthAdminGuard } from './guard/auth-admin.guard'
import { AuthGuard } from './guard/auth.guard'
import { DdcCookiepolicyComponent } from './legislation/ddc-cookiepolicy/ddc-cookiepolicy.component'
import { DdcPrivacypolicyComponent } from './legislation/ddc-privacypolicy/ddc-privacypolicy.component'
import { DdcTermsandconditionsComponent } from './legislation/ddc-termsandconditions/ddc-termsandconditions.component'
import { QuizDetailPageComponent } from './pages/quiz-detail/quiz-detail-page.component'
import { QuizzesPageComponent } from './pages/quizzes/quizzes-page.component'
import { DdcFlashcardModeComponent } from './shared/ddc/ddc-flashcard-mode/ddc-flashcard-mode.component'
import { DdcFlashcardPageComponent } from './shared/ddc/ddc-flashcard-page/ddc-flashcard-page.component'
import { DdcNoAccessComponent } from './shared/ddc/ddc-no-access/ddc-no-access.component'

export const routes: Routes = [
  { path: 'maintenance', component: DdcUnderConstructionComponent },
  { path: '', component: DdcHomeComponent, canActivate: [AuthGuard] },
  { path: 'home', component: DdcHomeComponent, canActivate: [AuthGuard] },

  { path: 'signup', component: DdcSignupComponent },
  { path: 'termsandconditions', component: DdcTermsandconditionsComponent },
  { path: 'privacypolicy', component: DdcPrivacypolicyComponent },
  { path: 'cookiepolicy', component: DdcCookiepolicyComponent },
  { path: 'verification', component: DdcVerificationComponent },

  { path: 'login', component: DdcLoginComponent },
  { path: 'find_account', component: DdcFindAccountComponent },
  { path: 'reset_password/:token/:code/:user_id', component: DdcResetPasswordComponent },

  { path: 'store', component: DdcStoreComponent, canActivate: [AuthGuard] },
  { path: 'store/:category', component: DdcStoreCategoryComponent, canActivate: [AuthGuard] },
  // { path: 'profile', component: DdcUserProfileComponent },
  { path: 'search', component: DdcSearchComponent, canActivate: [AuthGuard] },

  { path: 'library', component: DdcLibraryComponent, canActivate: [AuthGuard] },
  { path: 'library/:chip_code', component: DdcLibraryComponent, canActivate: [AuthGuard] },
  {
    path: 'library/dic/:dic_id/:dic_owner',
    component: DdcLibraryDicComponent,
    canActivate: [AuthGuard],
  },

  { path: 'saved', component: DdcSavedComponent, canActivate: [AuthGuard] },

  { path: 'network', component: DdcNetworkComponent, canActivate: [AuthGuard] },
  { path: 'network/:chip_code', component: DdcNetworkComponent, canActivate: [AuthGuard] },

  { path: 'users/:username', component: DdcUserProfileComponent, canActivate: [AuthGuard] },
  {
    path: 'users/:username/:chip_code',
    component: DdcUserProfileComponent,
    canActivate: [AuthGuard],
  },

  { path: 'collections/:coll_id', component: DdcCollectionPageComponent, canActivate: [AuthGuard] },
  {
    path: 'collections/:coll_id/:coll_name',
    component: DdcCollectionPageComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'flashcard-mode/:dictionaryId',
    component: DdcFlashcardModeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'flashcards/:dictionaryId/:type',
    component: DdcFlashcardPageComponent,
    canActivate: [AuthGuard],
  },

  { path: 'lingo', component: DdcLingoComponent, canActivate: [AuthGuard] },
  { path: 'canvas', component: DdcCanvasComponent, canActivate: [AuthGuard] },
  { path: 'agents', component: DdcAgentsComponent, canActivate: [AuthGuard] },
  { path: 'quizzes', component: QuizzesPageComponent, canActivate: [AuthGuard] },
  { path: 'quiz/:id', component: QuizDetailPageComponent, canActivate: [AuthGuard] },

  { path: 'pricing', component: DdcPricingComponent },

  { path: 'settings', component: DdcSettingComponent, canActivate: [AuthGuard] },

  { path: 'notifications', component: DdcNotificationsComponent, canActivate: [AuthGuard] },

  { path: 'no_access', component: DdcNoAccessComponent },

  { path: 'billing', component: DdcBillingComponent, canActivate: [AuthGuard] },
  {
    path: 'admin',
    component: DdcAdminPanelComponent,
    canActivate: [AuthAdminGuard],
  },
  {
    path: 'admin/ai',
    component: DdcAdminAiComponent,
    canActivate: [AuthAdminGuard],
  },
  {
    path: 'admin/users',
    component: DdcUserManagementComponent,
    canActivate: [AuthAdminGuard],
  },
]

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
